<form [formGroup]="reportForm" fxLayout="column" fxLayoutGap="1.070rem" class="neq-dialog">
  <h1>{{ 'label.user.rawmaterials.report.title' | translate }}</h1>

  <neq-group [label]="'label.common.matrices' | translate" formArrayName="matrices">
    <mat-checkbox *ngFor="let matrix of matrices; let i=index" [formControlName]="i" class="mat-form-field">
      {{ matrix.label }}
    </mat-checkbox>
  </neq-group>
  <div *ngIf="reportForm.controls.matrices.errors?.minNotNullChildren" class="error">
    {{ 'error.user.rawmaterials.report.not-enough-matrices' | translate }}
  </div>
  <div *ngIf="reportForm.controls.matrices.errors?.maxNotNullChildren" class="error">
    {{ 'error.user.rawmaterials.report.too-much-matrices' | translate }}
  </div>

  <neq-group [label]="'label.common.nutrient-classes' | translate" formArrayName="classes">
    <mat-checkbox *ngFor="let nutclass of classes; let i=index" [formControlName]="i" class="mat-form-field">
      {{ nutclass.name }}
    </mat-checkbox>
  </neq-group>
  <div *ngIf="reportForm.controls.classes.errors?.minNotNullChildren" class="error">
    {{ 'error.user.rawmaterials.report.not-enough-nutrient-classes' | translate }}
  </div>

  <mat-checkbox formControlName="note">
    {{ 'label.user.rawmaterials.report.include-note' | translate }}
  </mat-checkbox>

  <div class="asi-container" fxLayout="row" fxLayoutAlign="end center">
    <button pButton class="neq-primeng-button-text" label="{{ 'label.common.edition.cancel' | translate }}" (click)="cancel()"></button>
    <button pButton class="neq-primeng-button-text" label="{{ 'label.common.edition.confirm' | translate }}" [disabled]="processing || reportForm.invalid" (click)="process()"></button>
  </div>
</form>
